import { forwardRef } from '@chakra-ui/system';

import Text, { type TextProps } from 'components/_core/Text';

const Description = forwardRef<TextProps, 'p'>((props, ref) => (
  <Text paddingTop="space-16" ref={ref} {...props} />
));

export default Description;
